import axios from "axios";
import { AddOnCreationDTO, AddOnDTO, AddOnUpdateDTO, findAllAddOnsFiltersDTO, findAllAddOnsResponseDTO } from "./dto";
import { AddOnService } from "./service";
import { keycloak } from "../../../../lib/keycloak";

export class AddOnServiceImpl implements AddOnService {
    public createAddOn(data: AddOnCreationDTO): Promise<number> {
        return axios.post("/api/add-on",
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public updateAddOn(id: string, data: AddOnUpdateDTO): Promise<void> {

        return axios.put("/api/add-on/" + id,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public getAddOns(filters: findAllAddOnsFiltersDTO): Promise<findAllAddOnsResponseDTO> {
        return axios.get("/api/add-on", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page,
                order: filters.order,
                customerDataById: filters.customerDataId,
                sort: filters.sort,
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public getAddOnById(id: string): Promise<AddOnDTO> {
        return axios.get("/api/add-on/" + id, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public deleteAddOn(id: string): Promise<void> {
        return axios.delete("/api/add-on/" + id, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "DELETE",
            }
        }).then((response) => response.data)
    }
}
